module.exports = __webpack_public_path__ + "static/img/1en.cf373c2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/desc/02keepAlive/oppo/1en.png
// module id = BE93
// module chunks = 0